module Meevo.Plugins.QuickbooksDesktop {
    import ObjectStateEnum = Meevo.Model.ObjectStateEnum;

    export interface IConnectionSetupInfo {
        applicationConnection: IApplicationConnection,
        //applicationConnectionDetail?: IApplicationConnectionDetail
    }

    export interface IApplicationConnection {
        applicationConnectionDisplayName?: string;
        applicationConnectionUserName?: string;
        applicationConnectionPassword?: string;
        undepositedFundsAccountExternalId: string;
        externalApplicationEnum: ExternalApplicationEnum;
        applicationConnectionTypeEnum: ConnectionVersionEnum;
        objectStateEnum: ObjectStateEnum;
        entityVersion: number;
        includeMonetaryPayments: boolean;
        applicationConnectionUrl?: string;
        applicationConnectionId?: Guid;
        meevoSummaryCustomerExternalId?: string;
        meevoSummaryDistributorExternalId?: string;
        taxAgencyExternalId?: string;
    }

    export interface IAccountSystemList {
        id: number;
        displayName: string;
        objectStateEnum: number;
        defaultAccountName: string;
        isDisabled: boolean;
        accountType: ExternalAccountTypeEnum;
    }

    export interface IAccountInfo {
        displayName?: string;
        accountExternalDisplayName: string;
        accountExternalFullName?: string;
        accountSId: number;
        accountSDisplayName: string;
        externalAccoutId?: string;
        tenantId?: number;
        applicationConnectionId?: Guid;
        accountId?: string;
        entityVersion?: number;
        accountExternalId?: string;
        displayCategory: number;
    }

    export interface IExternalAccount {
        listID: string;
        //fullName: string;
        name: string;
        accountType: ExternalAccountTypeEnum;
    }

    // Main tab's interface
    export interface IConnectionListItem {
        applicationConnectionId: Guid;
        applicationConnectionDisplayName: string;
        entityVersion: number;
    }

    export interface IAccountsSetup {
        accountSetup: {
            accounts: Array<IAccountInfo>;
        };
        paymentTypeSetup: {
            items: Array<IPaymentAccount>;
        };
    }

    export interface IAccountCountRequest {
        criteria: IAccountCountCriteria;
        asLocationId: number;
    }

    interface IAccountCountCriteria {
        displayName: string;
        url: string;
        realmId: string;
        objectState: ObjectStateEnum;
        filter: string;
        maintenanceMode: boolean;
        isGlobal: boolean;
    }

    export interface IToolTip {
        value: ToolTipEnum,
        template: string
    }

    export interface IScreenList {
        type: MainTabScreens,
        headerTitle: () => string,
        viewPath: string,
        nextButtonHandler?: () => ng.IPromise<ScreenResult>,
        backButtonHandler?: Function,
        finishButtonHandler?: any,
        isNextButtonHidden?: boolean,
        isCancelButtonHidden?: boolean,
        isBackButtonShown?: boolean,
        isFinishButtonShown?: boolean
    }

    export interface IPaymentTypeCriteria {
        criteria: {
            includeNonMonetary: number;
        };
        pageNumber: number;
        itemsPerPage: number;
    }

    export interface IPaymentAccount {
        tenantId?: number,
        applicationConnectionId?: Guid,
        paymentTypeId: string,
        paymentTypeName?: string,
        entityVersion?: number,
        paymentTypeAccountExternalId: string,
        paymentTypeAccountExternalDisplayName: string,
        paymentSubCategory: Meevo.Model.PaymentSubCategoryEnum,
        accountType?: ExternalAccountTypeEnum,
        paymentTypeSId: number
    }

    export interface IPaymentOptions {
        [key: string]: IPaymentAccount[]
    }

    export interface IAccountsRetentionStatus {
        applicationConnectionId: Guid;
        items: IAccountRetentionStatus[];
    }

    interface IAccountRetentionStatus {
        entityDisplayName: string;
        messages: string[];
    }

    // Sync tab's interface
    export interface ISyncRequestData {
        id: Guid;
        startDate: Date | string;
        endDate: Date | string;
    }

    export interface ISyncDate {
        sync: ISyncDateRange;
        deleteSync: ISyncDateRange;
    }

    interface ISyncDateRange {
        from: Date;
        to: Date;
    }

    export interface ISyncOperation {
        accountSyncQueueHeaderId: Guid;
        actionTypeEnum: SyncActionTypeEnum;
        applicationConnectionId: Guid;
        processingStatus: SyncProcessingStatusEnum;
        numAttempts: number;
        dateCreated: Date | string;
        dateToProcessFrom: Date | string;
        dateToProcessTo: Date | string;
    }

    export interface IQueue {
        accountSyncQueueHeaderId: string;
        actionTypeEnum: number;
        applicationConnectionId: string;
        dateCreated: Date;
        dateToProcessFrom: Date;
        dateToProcessTo: Date;
        numAttempts: number;
        processingStatus: number;
        isSelected: boolean;
    }

    export interface IQueueDelete {
        applicationConnectionId: string;
        accountSyncQueueHeaderId: string;
    }

    export interface IPaymentTypeListItem {
        id?: string;
        displayName?: string;
        entityVersion?: number;
        objectState?: ObjectStateEnum;
        paymentCategoryDisplayName: string;
        paymentCategory: Meevo.Model.PaymentCategoryEnum;
        paymentSubCategory: Meevo.Model.PaymentSubCategoryEnum;
        paymentTypeId?: string;
        paymentTypeName: string;
        paymentTypeSId: number;
    }

    export enum ExternalAccountTypeEnum {
        ProductIncome = 1,
        ServiceIncome = 2,
        OtherIncome = 3,
        AccountReceivable = 4,
        InventoryAssets = 5,
        CostOfGoodsSold = 6,
        Liabilities = 7,
        ExpenseAccount = 8,
        CashDrawer, Bank = 9,
        Other = 101,
        Income = 10,
        OtherCurrentAsset = 11,
        OtherAsset = 12,
        FixedAsset = 13
    }

    export enum ToolTipEnum {
        ProductIncome,
        ServiceIncome,
        OtherIncome,
        AccountsReceivable,
        InventoryAssets,
        CostofGoodsSoldAccount,
        Liabilities,
        ExpenseAccount
    }

    export enum ExternalApplicationEnum {
        QuickbooksDesktop = 1
    }

    export enum ConnectionVersionEnum {
        Online,
        Local
    }

    export enum QuickbooksDesktopTabsEnum {
        Main,
        Sync,
        Queue,
        Logs
    }

    export enum MainTabScreens {
        Welcome,
        Create,
        ConnectingFile,
        SettingsAccount,
        PaymentSetup,
        Finish,

        Edit,
        Delete
    }

    export enum ProductInventoryTrackingLevel {
        Default,
        Advanced
    }

    export type ScreenResult = {
        isNextStepAllowed: boolean,
        screen?: MainTabScreens
    }

    export enum SyncProcessingStatusEnum {
        NotProcessed = 0,
        InProcess = 1,
        Complete = 2,
        Failed = 3,
        InError = 4
    }

    export enum SyncActionTypeEnum {
        Sync = 0,
        Delete = 1
    }
}
